import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'lib-stepper-navigator',
	templateUrl: './stepper-navigator.component.html',
	styleUrls: ['./stepper-navigator.component.css']
})
export class StepperNavigatorComponent implements OnInit {

	@Input()
	direction: string;

	@Input()
	isFinal: boolean;

	@Input()
	form: FormGroup;

	@Input()
	isContainerValid: boolean;

	@Output()
	complete: EventEmitter<any> = new EventEmitter<any>();

	@Output()
	goBackward: EventEmitter<any> = new EventEmitter<any>();

	@Output()
	goForward: EventEmitter<any> = new EventEmitter<any>();

	@Output()
	salvaBozza: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }
	ngOnInit() {
		// console.log("isContainerValid", this.isContainerValid);
	}

	canGoForWard(): boolean {
		let forward = false;
		if (this.direction === 'only-forward' || this.direction === 'both-ways') {
			forward = true;;
		}
		return forward;
	}

	canGoBackWard(): boolean {
		let backWard = false;
		if (this.direction === 'only-backward' || this.direction === 'both-ways') {
			backWard = true;;
		}
		return backWard;
	}

	canComplete(): boolean {
		let complete = false;
		if (this.isFinal && this.isContainerValid) {
			complete = true;
		}
		return complete;
	}
	
	onComplete() {
		this.complete.emit();
	}

	onForward() {
		this.goForward.emit();
	}

	onBackward() {
		this.goBackward.emit();
	}

	onSalvaBozza() {
		this.salvaBozza.emit();
	}
}